import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import Dashboard from "./components/dashboard";
import CP from "./components/CP";
import TAS from "./components/TAS";
import SOS from "./components/SOS";
import SAMobile from "./components/SAMobileView";
import LP from "./components/LP";
import Warning from "./components/Warning";

const router = createHashRouter([
  {
    path: "/cp",
    element: <CP />,
  },
  {
    path: "/tas",
    element: <TAS />,
  },
  {
    path: "/sos",
    element: <SOS />,
  },
  {
    path: "/saMobile",
    element: <SAMobile />,
  },
  {
    path: "/lp",
    element: <LP />,
  },
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/warning",
    element: <Warning />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
